module.exports = __webpack_public_path__ + "static/media/Executive-car.dd636136.png";